/* Studio Zen: motion and navigation behaviour for the szw-* sections. Small and dependency-free. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- reveal on scroll -------------------------------------------------------------------------
  function watchReveals(root) {
    var items = (root || document).querySelectorAll('.szw-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduced) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    items.forEach(function (el) { revealObserver.observe(el); });
  }
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;


  // --- hero: slow crossfade between stills ---------------------------------------------------------
  function initHero() {
    document.querySelectorAll('[data-szw-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-szw-slide]');
      var dots = hero.querySelectorAll('[data-szw-dot]');
      if (slides.length < 2) return;
      var interval = parseInt(hero.dataset.interval, 10) || 7000;
      var autoplay = hero.dataset.autoplay === 'true' && !reduced;
      var current = 0;
      var timer = null;
      hero.style.setProperty('--szw-interval', interval + 'ms');

      // Slides after the first keep their photograph in data-srcset / data-src until it is needed.
      function fetchSlide(index) {
        var slide = slides[(index + slides.length) % slides.length];
        if (!slide || slide.dataset.szwFetched) return;
        slide.dataset.szwFetched = '1';
        slide.querySelectorAll('[data-srcset]').forEach(function (node) { node.srcset = node.getAttribute('data-srcset'); node.removeAttribute('data-srcset'); });
        slide.querySelectorAll('[data-src]').forEach(function (node) { node.src = node.getAttribute('data-src'); node.removeAttribute('data-src'); });
      }
      // the next slide, once the page itself has finished loading (or a dot is used, whichever is first)
      function warm() { window.setTimeout(function () { fetchSlide(current + 1); }, 1200); }
      if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once: true });

      function go(index) {
        current = (index + slides.length) % slides.length;
        fetchSlide(current);
        fetchSlide(current + 1);
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === current);
          if (i === current) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
        });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
        restart();
      }
      function restart() {
        window.clearTimeout(timer);
        hero.dataset.playing = 'false';
        if (!autoplay) return;
        // re-trigger the pager line animation
        void hero.offsetWidth;
        hero.dataset.playing = 'true';
        timer = window.setTimeout(function () { go(current + 1); }, interval);
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.dataset.szwDot, 10)); });
      });
      // keep a slide on screen while someone is reading or tabbing through it
      hero.addEventListener('focusin', function () { window.clearTimeout(timer); hero.dataset.playing = 'false'; });
      hero.addEventListener('focusout', restart);
      document.addEventListener('visibilitychange', function () { if (document.hidden) window.clearTimeout(timer); else restart(); });
      restart();
    });
  }

  // --- first visit of the session, homepage only: the red sun, then the page ---------------------------
  function initIntro() {
    if (!document.documentElement.hasAttribute('data-szw-intro')) return; // off by default since 2026-09-26
    if (reduced || !document.body.classList.contains('index-template')) return;
    try {
      if (window.sessionStorage.getItem('szwIntro')) return;
      window.sessionStorage.setItem('szwIntro', '1');
    } catch (e) { return; }
    var intro = document.createElement('div');
    intro.className = 'szw-intro';
    intro.setAttribute('aria-hidden', 'true');
    intro.innerHTML = '<span class="szw-intro__sun"></span>';
    document.body.appendChild(intro);
    window.setTimeout(function () { intro.remove(); }, 2800);
  }

  // --- header: transparent over a hero, solid once scrolled, tucks away on the way down -----------
  function initHeader() {
    var section = document.querySelector('.szw-header-section');
    if (!section) return;
    // ?header=oneline|centered|searchrow|classic previews a header layout without saving it; it is
    // remembered for the browser session so it survives clicking around. The saved setting is untouched.
    try {
      var bar = section.querySelector('[data-szw-header]');
      var asked = (location.search.match(/[?&]header=(oneline|centered|searchrow|classic)\b/) || [])[1];
      if (asked) window.sessionStorage.setItem('szwHeader', asked);
      var pick = window.sessionStorage.getItem('szwHeader');
      if (bar && pick) { bar.className = bar.className.replace(/szw-header--(classic|oneline|centered|searchrow)/, 'szw-header--' + pick); }
      // the one-line layout has a short field: use the short placeholder so it is not cut off
      var field = bar && bar.querySelector('input[data-szw-ph-short]');
      if (field && /szw-header--oneline/.test(bar.className)) field.placeholder = field.getAttribute('data-szw-ph-short');
    } catch (e) {}
    var firstMain = document.querySelector('main .shopify-section');
    var overHero = !!(firstMain && firstMain.querySelector('[data-szw-hero]'));
    section.classList.toggle('is-over', overHero);

    // 10/15: --szw-head-real = the header's real height, kept current (phone size var, one-line / classic layout,
    // open search row, fonts arriving). Sticky bars under the header use it (collection toolbar; szw.js sets it too).
    var head = section;
    function setHeadH() { var h = Math.round(head.getBoundingClientRect().height); if (h > 0) document.documentElement.style.setProperty('--szw-head-real', h + 'px'); }
    setHeadH();
    if (window.ResizeObserver) new ResizeObserver(setHeadH).observe(head);
    else window.addEventListener('resize', setHeadH);

    var last = window.scrollY;
    function onScroll() {
      var y = window.scrollY;
      section.classList.toggle('is-scrolled', y > 40);
      // hide when moving down past the fold, show on any upward movement
      // 10/12: header stays on screen while scrolling (7 of 10 peer sites keep it; none hide on scroll-down)
      section.classList.remove('is-hidden');
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- mobile drawer ----------------------------------------------------------------------------
  function initDrawer() {
    var drawer = document.querySelector('[data-szw-drawer]');
    var opener = document.querySelector('[data-szw-drawer-open]');
    if (!drawer || !opener) return;
    function set(open) {
      drawer.hidden = !open;
      opener.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) drawer.querySelector('[data-szw-drawer-close]').focus();
      else opener.focus();
    }
    opener.addEventListener('click', function () { set(true); });
    drawer.querySelector('[data-szw-drawer-close]').addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) set(false); });
  }

  // --- materials index: the photograph follows the hovered / focused name ---------------------------
  function initMaterials() {
    document.querySelectorAll('[data-szw-materials]').forEach(function (root) {
      var links = root.querySelectorAll('[data-szw-material]');
      var frames = root.querySelectorAll('[data-szw-frame]');
      function show(index) {
        links.forEach(function (l) { l.classList.toggle('is-active', l.dataset.szwMaterial === index); });
        frames.forEach(function (f) { f.classList.toggle('is-active', f.dataset.szwFrame === index); });
      }
      links.forEach(function (link) {
        link.addEventListener('mouseenter', function () { show(link.dataset.szwMaterial); });
        link.addEventListener('focus', function () { show(link.dataset.szwMaterial); });
      });
    });
  }

  // --- product rail arrows ------------------------------------------------------------------------
  function initRails() {
    document.querySelectorAll('[data-szw-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-szw-rail-track]');
      if (!track) return;
      function move(direction) {
        var item = track.querySelector('li');
        var step = item ? item.getBoundingClientRect().width * 2 : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * step, behavior: reduced ? 'auto' : 'smooth' });
      }
      var prev = rail.querySelector('[data-szw-rail-prev]');
      var next = rail.querySelector('[data-szw-rail-next]');
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
    });
  }

  // --- quiet parallax on full-bleed features -------------------------------------------------------
  function initParallax() {
    if (reduced) return;
    var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-szw-parallax]'));
    if (!blocks.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      blocks.forEach(function (block) {
        var rect = block.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2); // -1 .. 1
        var img = block.querySelector('[data-szw-parallax-img]');
        if (img) img.style.transform = 'translate3d(0,' + (progress * -6).toFixed(2) + '%,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // --- product cards: the hover photograph is fetched when a pointer first reaches the card -----------
  // (never on a touch screen, where it was half of every grid's image downloads for nothing)
  function initCardHover() {
    function arm(event) {
      var link = event.target.closest ? event.target.closest('.szw-card__link') : null;
      if (!link) return;
      var img = link.querySelector('img[data-szw-hover]');
      if (!img) return;
      img.addEventListener('load', function () { img.classList.add('is-ready'); }, { once: true });
      img.srcset = img.getAttribute('data-szw-hover');
      img.removeAttribute('data-szw-hover');
    }
    document.addEventListener('mouseover', arm, { passive: true });
    document.addEventListener('focusin', arm);
  }

  // --- silent films: fetched only when they scroll near, paused when off screen ---------------------
  function initFilms() {
    var films = document.querySelectorAll('video[data-szw-film]');
    if (!films.length) return;
    // A poster="" is downloaded with the page even when the film is five screens down. Films below the
    // fold carry it in data-szw-poster instead and get it a screen or two before they arrive.
    function still(film) { if (film.dataset.szwPoster) { film.poster = film.dataset.szwPoster; film.removeAttribute('data-szw-poster'); } }
    if (reduced || !('IntersectionObserver' in window)) { films.forEach(still); return; } // the poster stays
    var stills = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { still(entry.target); stills.unobserve(entry.target); } });
    }, { rootMargin: '1400px 0px' });
    films.forEach(function (film) { if (film.dataset.szwPoster) stills.observe(film); });
    // Fetch the film a screen or so ahead, so it is already moving when it scrolls into view. On a wide screen the
    // first film sits below the fold and used to start loading only at 300px, showing its poster for seconds.
    function allowed(film) { return !film.dataset.szwFilmMin || window.matchMedia('(min-width: ' + film.dataset.szwFilmMin + 'px)').matches; }
    var warm = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var film = entry.target;
        if (!entry.isIntersecting || !allowed(film)) return;
        if (!film.src) { film.preload = 'auto'; film.src = film.dataset.szwFilm; }
        warm.unobserve(film);
      });
    }, { rootMargin: '1200px 0px' });
    films.forEach(function (film) { warm.observe(film); });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var film = entry.target;
        if (entry.isIntersecting) {
          // data-szw-film-min: a film that is hidden on narrow screens is never downloaded there
          if (!allowed(film)) return;
          if (!film.src) film.src = film.dataset.szwFilm;
          var playing = film.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else if (film.src) {
          film.pause();
        }
      });
    }, { rootMargin: '300px 0px' });
    films.forEach(function (film) { observer.observe(film); });
  }

  // --- collection filters: submit on change; one panel open at a time -----------------------------
  function initFilters() {
    document.querySelectorAll('[data-szw-filters]').forEach(function (form) {
      form.addEventListener('change', function (event) {
        if (event.target.matches('input[type="checkbox"], [data-szw-sort]')) form.submit();
      });
      var groups = form.querySelectorAll('details');
      groups.forEach(function (group) {
        group.addEventListener('toggle', function () {
          if (group.open) groups.forEach(function (other) { if (other !== group) other.open = false; });
        });
      });
      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) groups.forEach(function (group) { group.open = false; });
      });
    });
  }

  // --- collection grid size: Compact (catalog) or Large (editorial); remembered on this device -------------
  function initView() {
    var grid = document.querySelector('[data-szw-grid]');
    var buttons = document.querySelectorAll('[data-szw-view]');
    if (!grid || !buttons.length) return;
    // 10/17 (Toshi: on a phone the photos were too big, and the size buttons did nothing in Colorways / In stock): three
    // sizes - large | compact (medium, the default) | small - set on <html data-szw-size>, so the CSS sizes the Patterns
    // grid AND the Colorways / In stock grids (.szw-cw) alike, on every screen.
    function apply(mode) {
      if (['large', 'compact', 'small'].indexOf(mode) < 0) mode = 'compact';
      grid.classList.toggle('szw-grid--compact', mode !== 'large');
      document.documentElement.setAttribute('data-szw-size', mode);
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.szwView === mode)); });
    }
    // phone default = small (Toshi 10/17); a size the visitor picked is remembered and wins
    var def = window.matchMedia('(max-width: 749px)').matches ? 'small' : 'compact';
    var saved = def;
    try { saved = window.localStorage.getItem('szwGrid') || def; } catch (e) {}
    apply(saved);
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.dataset.szwView);
        try { window.localStorage.setItem('szwGrid', button.dataset.szwView); } catch (e) {}
      });
    });

    var head = document.querySelector('[data-szw-chead]');
    var toggle = head && head.querySelector('[data-szw-chead-toggle]');
    if (toggle) {
      // a short description is not cut off: no "Read more" under it
      var desc = head.querySelector('.szw-chead__desc');
      var fit = function () {
        if (!desc || head.classList.contains('is-open')) return;
        toggle.style.display = desc.scrollHeight <= desc.clientHeight + 2 ? 'none' : '';
      };
      fit();
      window.addEventListener('load', fit);
      window.addEventListener('resize', fit);
      toggle.addEventListener('click', function () {
        var open = head.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? 'Read less' : 'Read more';
      });
    }
  }

  // --- browse grid tabs -----------------------------------------------------------------------------
  function initTabs() {
    document.querySelectorAll('[data-szw-browse]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-szw-tab]');
      var panels = root.querySelectorAll('[data-szw-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', String(on));
          });
          panels.forEach(function (p) { p.hidden = p.dataset.szwPanel !== tab.dataset.szwTab; });
        });
      });
    });
  }

  // --- related patterns: fetch Shopify's recommendations for this product and swap them in ------------
  function initRelated() {
    document.querySelectorAll('[data-szw-related]').forEach(function (section) {
      if (section.querySelector('[data-szw-rail-track]')) return; // already rendered
      // 10/12: a colour page of a split design family (Abstract Art Facet / Check / Parquet) brings the family's other
      // designs in a <template> (sections/szw-related); they lead the rail, even when Shopify recommends nothing
      var famT = section.querySelector('template[data-szw-family]');
      var famTrack = famT && famT.content.querySelector('[data-szw-rail-track]');
      if (famTrack && !famTrack.children.length) famTrack = null;
      fetch(section.dataset.url)
        .then(function (response) { return response.text(); })
        .catch(function () { return ''; })
        .then(function (html) {
          var fresh = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-szw-related]') : null;
          var track = fresh && fresh.querySelector('[data-szw-rail-track]');
          if (famTrack) {
            if (!track) {
              fresh = document.createElement('div');
              fresh.appendChild(document.importNode(famT.content, true));
            } else {
              var first = track.firstChild;
              Array.prototype.forEach.call(famTrack.children, function (li) { track.insertBefore(document.importNode(li, true), first); });
            }
            var oldT = fresh.querySelector('template[data-szw-family]');
            if (oldT) oldT.remove();
          }
          if (!fresh || !fresh.querySelector('[data-szw-rail-track]')) { section.hidden = true; return; }
          // B1: no colour page of the pattern this page belongs to (and, on a colour page, not its pattern card either)
          var own = section.getAttribute('data-szw-pattern'), ownColour = section.hasAttribute('data-szw-own-colour');
          if (own) fresh.querySelectorAll('[data-szw-rail-track] > li[data-szw-pattern]').forEach(function (li) {
            if (li.getAttribute('data-szw-pattern') === own && (ownColour || li.hasAttribute('data-szw-colour') || li.hasAttribute('data-szw-design'))) li.remove();
          });
          // 10/12: no design twice - a colour page or design card whose design is already in the rail goes, and no
          // link twice. Two different patterns that share a name (Fractal) are both kept, as before.
          var seenPat = {}, seenUrl = {};
          fresh.querySelectorAll('[data-szw-rail-track] > li').forEach(function (li) {
            var a = li.querySelector('a[href]'), u = a ? a.getAttribute('href').split('?')[0] : '';
            var p = li.getAttribute('data-szw-pattern') || '';
            var byName = li.hasAttribute('data-szw-colour') || li.hasAttribute('data-szw-design');
            if ((u && seenUrl[u]) || (byName && p && seenPat[p])) { li.remove(); return; }
            if (u) seenUrl[u] = 1;
            if (p) seenPat[p] = 1;
          });
          if (!fresh.querySelector('[data-szw-rail-track] > li')) { section.hidden = true; return; }
          section.innerHTML = fresh.innerHTML;
          initRails();
          watchReveals(section);
        })
        .catch(function () { section.hidden = true; });
    });
  }

  // B1 (launch, 10/10): collection grids ask Shopify for 250 products a request and print only the pattern cards (the
  // per-colour pages that share those lists from launch are left out in sections/szw-collection). When a collection
  // needs more than one request, the others are fetched here (same filters and sort, this section only) and their
  // cards joined in order; then the cards are shown "Patterns per page" at a time under the usual Previous / 1 2 3 /
  // Next row. The page sits in the address as #page-2, so the back button and a shared link keep it. An old ?page=2
  // link (36 a page before launch) opens the same screenful. If a request fails, its plain page links stay.
  function initGridPages() {
    var grid = document.querySelector('[data-szw-grid][data-szw-per]');
    if (!grid) return;
    var pages = +grid.dataset.szwPages || 1, here = +grid.dataset.szwPage || 1, per = +grid.dataset.szwPer || 36;
    var count = document.querySelector('.szw-filters__count'), requestNav = document.querySelector('[data-szw-request-pages]');
    var failed = false, jobs = [];
    if (pages > 1 && grid.dataset.szwSection) {
      for (var n = 1; n <= pages; n++) {
        if (n === here) { jobs.push(Promise.resolve(null)); continue; }
        var u = new URL(location.href); u.hash = ''; u.searchParams.set('page', n); u.searchParams.set('section_id', grid.dataset.szwSection);
        jobs.push(fetch(u.toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) {
            var g = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-szw-grid]');
            if (!g) { failed = true; return []; }
            return Array.prototype.slice.call(g.children);
          })
          .catch(function () { failed = true; return []; }));
      }
    }
    function key(li) { var a = li.querySelector('a[href]'); return a ? a.getAttribute('href').split('?')[0] : ''; }
    // 10/10: a card that is never shown (szw-card-gone: no colour of it on sale here; or hidden) takes no place on a
    // screen and is not counted. sections/szw-collection already leaves these out; this catches any that slip through.
    function gone(li) { return li.hidden || !!li.querySelector('.szw-card-gone') || li.style.display === 'none'; }
    var dropped = 0;
    Array.prototype.slice.call(grid.children).forEach(function (li) { if (gone(li)) { li.remove(); dropped++; } });
    // first screenful at once, so the grid does not jump when the other requests arrive
    Array.prototype.forEach.call(grid.children, function (li, i) { li.classList.toggle('szw-paged-out', i >= per); });
    grid.szwReady = Promise.all(jobs).then(function (parts) {
      if (pages > 1) {
        var seen = {}, before = document.createDocumentFragment(), after = document.createDocumentFragment();
        Array.prototype.forEach.call(grid.children, function (li) { seen[key(li)] = 1; });
        parts.forEach(function (lis, i) {
          (lis || []).forEach(function (li) {
            var k = key(li);
            if (gone(li)) return;
            if (k && seen[k]) return;   // the list changed between two requests: never the same card twice
            seen[k] = 1;
            (i + 1 < here ? before : after).appendChild(document.importNode(li, true));
          });
        });
        grid.insertBefore(before, grid.firstChild);
        grid.appendChild(after);
        if (count) {
          var total = grid.children.length;
          count.textContent = total + (total === 1 ? ' pattern' : ' patterns');
          count.removeAttribute('data-szw-count-pending');
        }
        watchReveals(grid);
        if (!failed && requestNav) { requestNav.remove(); requestNav = null; }
      }
      else if (dropped && count && !count.hasAttribute('data-szw-count-pending')) {
        var shown = grid.children.length;
        count.textContent = shown + (shown === 1 ? ' pattern' : ' patterns');
      }
      // 10/17 (Toshi: "price low to high doesn't work"): Shopify sorts by the pattern page's own stored price, which is
      // not the "from" price the card shows (that comes from the colour pages). Re-order by the price on the card;
      // cards without a price go last, ties keep Shopify's order.
      var sortBy = new URL(location.href).searchParams.get('sort_by') || '';
      if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
        var dir = sortBy === 'price-ascending' ? 1 : -1;
        var priced = Array.prototype.map.call(grid.children, function (li, i) {
          var box = li.querySelector('.szw-card__price'), v = NaN;
          if (box) {
            var c = box.cloneNode(true);
            Array.prototype.forEach.call(c.querySelectorAll('s, del, .szw-price__compare'), function (x) { x.remove(); });
            var m = c.textContent.replace(/,/g, '').match(/\$\s?(\d+(?:\.\d+)?)/);
            if (m) v = parseFloat(m[1]);
          }
          return { li: li, v: v, i: i };
        });
        priced.sort(function (a, b) {
          var an = isNaN(a.v), bn = isNaN(b.v);
          if (an || bn) return an === bn ? a.i - b.i : (an ? 1 : -1);
          return a.v === b.v ? a.i - b.i : dir * (a.v - b.v);
        });
        priced.forEach(function (p) { grid.appendChild(p.li); });
      }
      var lis = Array.prototype.slice.call(grid.children), last = Math.max(1, Math.ceil(lis.length / per));
      var asked = (location.search.match(/[?&]page=(\d+)/) || [])[1];
      if (!failed && asked) {
        // the request page is joined now: drop ?page= from the address (and keep the screenful an old link meant)
        var clean = new URL(location.href); clean.searchParams.delete('page');
        if (!/^#page-\d+$/.test(clean.hash) && +asked > 1) clean.hash = 'page-' + asked;
        history.replaceState(history.state, '', clean.toString());
      }
      if (lis.length <= per || (failed && requestNav)) {
        lis.forEach(function (li) { li.classList.remove('szw-paged-out'); });   // no page row: every card shows
        return;
      }
      var nav = document.createElement('nav');
      nav.className = 'szw-pages'; nav.setAttribute('aria-label', 'Pagination'); nav.setAttribute('data-szw-client-pages', '');
      (requestNav || grid).parentNode.insertBefore(nav, requestNav ? requestNav : grid.nextSibling);
      function partsFor(p) {
        if (last <= 7) { var all = []; for (var i = 1; i <= last; i++) all.push(i); return all; }
        var out = [1];
        if (p > 3) out.push(0);
        for (var j = Math.max(2, p - 1); j <= Math.min(last - 1, p + 1); j++) out.push(j);
        if (p < last - 2) out.push(0);
        out.push(last);
        return out;
      }
      function show(p, scroll) {
        p = Math.min(Math.max(1, p || 1), last);
        lis.forEach(function (li, i) { li.classList.toggle('szw-paged-out', i < (p - 1) * per || i >= p * per); });
        nav.innerHTML = (p > 1 ? '<a class="szw-link" href="#page-' + (p - 1) + '">Previous</a>' : '') + '<ol role="list">' +
          partsFor(p).map(function (n) {
            return '<li>' + (n === 0 ? '<span>&hellip;</span>' : n === p ? '<span aria-current="page">' + n + '</span>' : '<a href="#page-' + n + '">' + n + '</a>') + '</li>';
          }).join('') + '</ol>' + (p < last ? '<a class="szw-link" href="#page-' + (p + 1) + '">Next</a>' : '');
        watchReveals(grid);
        // tile pictures that were measured while their card was hidden are measured again (szw.js listens to resize)
        window.dispatchEvent(new Event('resize'));
        if (scroll) window.scrollTo(0, Math.max(0, grid.getBoundingClientRect().top + window.pageYOffset - 140));
      }
      function fromHash() { return +((location.hash.match(/^#page-(\d+)$/) || [])[1] || 1); }
      show(fromHash(), false);
      window.addEventListener('hashchange', function () {
        if (location.hash === '' || /^#page-\d+$/.test(location.hash)) show(fromHash(), true);   // other #links (skip link) are left alone
      });
    });
  }

  // "Patterns | Colorways" on collection and search grids. Colorways = one close-up tile per colourway of every design on
  // the page (data printed by snippets/szw-card), labelled SKU / colour / pattern and linked to that colourway. The choice
  // is remembered per device. The pattern grid stays in the page, so filters, paging and the back button are unchanged.
  // 10/9 "In stock" (Toshi: designers must see exactly which colour / SKU is on the shelf): the Colorways tiles of EVERY page
  // of this collection, only colours with whole rolls in stock, each with its dye lots ("Lot #1: 5 rolls · Lot #2: 2 rolls";
  // one order ships from one lot). Lot data = "k" in the card JSON (snippets/szw-colour-stock, from the inventory read).
  function initColorways() {
    var grid = document.querySelector('[data-szw-grid]');
    var buttons = document.querySelectorAll('[data-szw-mode]');
    if (!grid || !buttons.length) return;
    var cw = null, st = null, current = 'patterns', count = document.querySelector('.szw-filters__count, .szw-shead__count'), countText = count ? count.innerHTML : '';
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function lotsText(k) {
      // "5,2" = rolls per lot; "30y,19y" = yards per lot (SZC, sold by the yard - Toshi 10/9)
      var raw = String(k || '').split(',').filter(Boolean), yd = raw.some(function (x) { return /y$/.test(x); });
      var l = raw.map(function (x) { return parseFloat(x); });
      if (!l.length) return '';
      function q(n) { return yd ? n + ' yd' : n + (n === 1 ? ' roll' : ' rolls'); }
      if (l.length === 1) return 'In stock · ' + q(l[0]) + ', one dye lot';
      return 'In stock · ' + l.map(function (n, i) { return 'Lot #' + (i + 1) + ': ' + q(n); }).join(' · ');
    }
    // 10/30 Toshi ("make it prettier"): the tile leads with the LARGEST SINGLE LOT in yards (designers quote in yards; one
    // order ships from one lot), rolls + the smaller lots underneath. The full lot list stays in the hover title and on the
    // colour page. y = yards per roll (custom.roll_size); 0 = unknown -> rolls only, never a guessed yardage.
    function stockHtml(k, y) {
      var raw = String(k || '').split(',').filter(Boolean), yd = raw.some(function (x) { return /y$/.test(x); });
      var l = raw.map(function (x) { return parseFloat(x) || 0; }).sort(function (a, b) { return b - a; });
      if (!l.length) return '';
      y = parseFloat(y) || 0;
      function r(n) { return n + (n === 1 ? ' roll' : ' rolls'); }
      function n1(n) { return String(Math.round(n * 10) / 10); }
      var top = l[0], more = l.length - 1, main, sub = [];
      if (yd) main = n1(top) + ' yd';
      else if (y > 0) { main = n1(top * y) + ' yd'; sub.push(r(top) + ' of ' + n1(y) + ' yd'); }
      else main = r(top);
      if (more) sub.push('+ ' + more + ' more ' + (more === 1 ? 'lot' : 'lots'));
      return '<span class="szw-cw__stock" title="' + esc(lotsText(k)) + '"><span class="szw-cw__lot">' + esc(main) + ' in one dye lot</span>' +
        (sub.length ? '<span class="szw-cw__lots">' + esc(sub.join(' · ')) + '</span>' : '') + '</span>';
    }
    function collect(root, onlyStock, seen) {
      var tiles = [];
      root.querySelectorAll('[data-szw-grid] > li').forEach(function (li) {
        if (li.hidden || li.style.display === 'none') return;
        var data = li.querySelector('[data-szw-cw]'), title = li.querySelector('.szw-card__title');
        if (!data) return;
        var list = []; try { list = JSON.parse(data.textContent); } catch (e) {}
        list.forEach(function (c) {
          if (onlyStock && !c.k) return;
          if (seen) { if (seen[c.u]) return; seen[c.u] = 1; }
          var lt = onlyStock ? stockHtml(c.k, c.y) : '';
          // A2 draft: lots + yards per roll ride on the tile for the trade "Yards | Ships now" box (assets/szw-yards.js)
          tiles.push('<li data-szw-k="' + esc(c.k || '') + '" data-szw-y="' + esc(c.y || 0) + '"><a class="szw-cw__tile" href="' + esc(c.u) + '"><span class="szw-cw__img"><img src="' + esc(c.i) + '" alt="' + esc((title ? title.textContent.trim() + ', ' : '') + c.c) + '" loading="lazy" width="500" height="500"></span>' +
            '<span class="szw-cw__sku">' + esc(c.s) + '</span><span class="szw-cw__name">' + esc(c.c) + '</span><span class="szw-cw__pattern">' + esc(title ? title.textContent.trim() : '') + '</span>' +
            // 10/17 Toshi: Colorways shows the price, In stock shows the lots (c.p = szw-price markup from our own template)
            (onlyStock ? lt : (c.p ? '<span class="szw-card__price szw-cw__price">' + c.p + '</span>' : '')) + '</a></li>');
        });
      });
      return tiles;
    }
    // 10/10 (site check: Natural's Colorways ran 26,700 px on one screen): the Colorways and In stock tiles are shown
    // twice "Patterns per page" at a time (72), under the same Previous / 1 2 3 / Next row as the pattern grid. The page
    // sits in the address as #cw-page-2 / #stock-page-2, so it never moves the pattern grid's own #page-N.
    var cwPer = 2 * (+grid.dataset.szwPer || 36);
    function pageList(ul, prefix) {
      if (ul.szwNav) { ul.szwNav.remove(); ul.szwNav = null; }
      // A2 draft: pageList runs again when "Ships now" filters the list; tiles it set aside (.szw-yd-out) are not paged
      if (ul.szwHash) { window.removeEventListener('hashchange', ul.szwHash); ul.szwHash = null; }
      var lis = Array.prototype.slice.call(ul.children).filter(function (li) { if (li.classList.contains('szw-yd-out')) { li.classList.remove('szw-paged-out'); return false; } return true; }), last = Math.max(1, Math.ceil(lis.length / cwPer));
      if (last < 2) { lis.forEach(function (li) { li.classList.remove('szw-paged-out'); }); return; }
      var nav = document.createElement('nav'), re = new RegExp('^#' + prefix + '-(\\d+)$');
      nav.className = 'szw-pages'; nav.setAttribute('aria-label', 'Pagination'); nav.setAttribute('data-szw-cw-pages', '');
      nav.hidden = ul.hidden;
      ul.parentNode.insertBefore(nav, ul.nextSibling);
      ul.szwNav = nav;
      function partsFor(p) {
        if (last <= 7) { var all = []; for (var i = 1; i <= last; i++) all.push(i); return all; }
        var out = [1];
        if (p > 3) out.push(0);
        for (var j = Math.max(2, p - 1); j <= Math.min(last - 1, p + 1); j++) out.push(j);
        if (p < last - 2) out.push(0);
        out.push(last);
        return out;
      }
      function show(p, scroll) {
        p = Math.min(Math.max(1, p || 1), last);
        lis.forEach(function (li, i) { li.classList.toggle('szw-paged-out', i < (p - 1) * cwPer || i >= p * cwPer); });
        nav.innerHTML = (p > 1 ? '<a class="szw-link" href="#' + prefix + '-' + (p - 1) + '">Previous</a>' : '') + '<ol role="list">' +
          partsFor(p).map(function (n) {
            return '<li>' + (n === 0 ? '<span>&hellip;</span>' : n === p ? '<span aria-current="page">' + n + '</span>' : '<a href="#' + prefix + '-' + n + '">' + n + '</a>') + '</li>';
          }).join('') + '</ol>' + (p < last ? '<a class="szw-link" href="#' + prefix + '-' + (p + 1) + '">Next</a>' : '');
        if (scroll && !ul.hidden) window.scrollTo(0, Math.max(0, ul.getBoundingClientRect().top + window.pageYOffset - 140));
      }
      function fromHash() { return +((location.hash.match(re) || [])[1] || 1); }
      show(fromHash(), false);
      ul.szwHash = function () { if (re.test(location.hash)) show(fromHash(), true); };
      window.addEventListener('hashchange', ul.szwHash);
    }
    function makeList(tiles) {
      var ul = document.createElement('ul'); ul.className = 'szw-cw'; ul.setAttribute('role', 'list'); ul.innerHTML = tiles.join('');
      ul.dataset.n = tiles.length;
      // same side margins as the pattern grid it replaces
      var gs = getComputedStyle(grid);
      ['paddingLeft', 'paddingRight', 'marginLeft', 'marginRight', 'maxWidth'].forEach(function (k) { ul.style[k] = gs[k]; });
      grid.parentNode.insertBefore(ul, grid.nextSibling);
      return ul;
    }
    function buildStock() {
      var seen = {}, tiles = collect(document, true, seen);
      st = makeList(tiles); st.dataset.loading = '1';
      // the other pages of this collection (same filters / sort), so the view covers the whole collection, not one page
      var last = 1;
      document.querySelectorAll('a[href*="page="]').forEach(function (a) { var m = a.href.match(/[?&]page=(\d+)/); if (m) last = Math.max(last, +m[1]); });
      var here = +((location.search.match(/[?&]page=(\d+)/) || [])[1] || 1), jobs = [];
      for (var n = 1; n <= last; n++) {
        if (n === here) continue;
        var u = new URL(location.href); u.searchParams.set('page', n); u.searchParams.delete('mode');
        jobs.push(fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
          return collect(new DOMParser().parseFromString(h, 'text/html'), true, seen);
        }).catch(function () { return []; }));
      }
      Promise.all(jobs).then(function (more) {
        more.forEach(function (t) { tiles = tiles.concat(t); });
        st.innerHTML = tiles.length ? tiles.join('') : '<li class="szw-cw__none">Nothing in this collection is on our shelf right now. Every colorway can be made to order.</li>';
        st.dataset.n = tiles.length; delete st.dataset.loading;
        if (tiles.length) pageList(st, 'stock-page');
        if (current === 'stock') setCount('stock');
        // A2 draft: the trade "Yards | Ships now" box (assets/szw-yards.js) works on this list once every page is in
        st.szwRepage = function () { pageList(st, 'stock-page'); };
        st.setAttribute('data-szw-stock', '');
        document.dispatchEvent(new CustomEvent('szw:stock-ready', { detail: { list: st } }));
      });
    }
    function setCount(mode) {
      if (!count) return;
      if (mode === 'stock' && st) count.innerHTML = st.dataset.loading ? 'Checking stock&hellip;' : st.dataset.n + (st.dataset.n === '1' ? ' colorway' : ' colorways') + ' in stock';
      else if (mode === 'colorways' && cw) count.innerHTML = cw.dataset.n + (cw.dataset.n === '1' ? ' colorway' : ' colorways') + (/page=\d/.test(location.search) || document.querySelector('.pagination, [class*=paginat]') ? ' on this page' : '');
      else count.innerHTML = countText;
    }
    function apply(mode) {
      current = mode;
      if (mode === 'colorways' && !cw) { cw = makeList(collect(document, false, null)); pageList(cw, 'cw-page'); }
      if (mode === 'stock' && !st) buildStock();
      grid.hidden = mode !== 'patterns';
      if (cw) { cw.hidden = mode !== 'colorways'; if (cw.szwNav) cw.szwNav.hidden = cw.hidden; }
      if (st) { st.hidden = mode !== 'stock'; if (st.szwNav) st.szwNav.hidden = st.hidden; }
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.szwMode === mode)); });
      document.documentElement.classList.toggle('szw-is-cw', mode !== 'patterns');
      document.documentElement.classList.toggle('szw-is-stock', mode === 'stock');   // A2 draft: shows the trade Yards box
      setCount(mode);
    }
    var saved = 'patterns';
    try { saved = window.localStorage.getItem('szwMode') || 'patterns'; } catch (e) {}
    if (saved === 'stock') saved = 'patterns';   // the stock view is asked for each time, never remembered
    // a link can ask for one view: ?mode=colorways (the bride slide opens every fumigated colour, not one card per pattern), ?mode=stock
    var asked = (location.search.match(/[?&]mode=(patterns|colorways|stock)/) || [])[1];
    if (asked) saved = asked;
    // B1: a collection grid first joins its other request pages (initGridPages); the views are built from the whole list
    var ready = (grid.szwReady || Promise.resolve()).catch(function () {});   // a failed join never blocks the views
    ready.then(function () { countText = count ? count.innerHTML : ''; apply(saved); });
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        ready.then(function () { apply(b.dataset.szwMode); });
        if (b.dataset.szwMode !== 'stock') { try { window.localStorage.setItem('szwMode', b.dataset.szwMode); } catch (e) {} }
      });
    });
  }

  // Product thumbnail strip (Hyper's Swiper, stock media-gallery.js left alone). When the page opens on a
  // colorway that sits after the installation photos, Swiper jumped the strip to it and overshot, leaving the
  // selected thumbnail a sliver at the top edge. Here: whenever the selected thumbnail changes, it is shown
  // whole with half of the one before it peeking out (so the strip reads as "more above"); if it already fits
  // in the first view, the strip stays at the start. A strip scrolled by hand is left where the visitor put it.
  function initThumbStrip() {
    var el = document.querySelector('.product__media-gallery-thumbails');
    if (!el) return;
    var tries = 0;
    (function wait() {
      var sw = el.swiper;
      if (!sw || !sw.slidesGrid || !sw.slidesGrid.length) { if (++tries < 40) setTimeout(wait, 150); return; }
      var lastActive = -1;
      function place(animate) {
        var slides = sw.slides, i = -1;
        for (var k = 0; k < slides.length; k++) if (slides[k].classList.contains('swiper-slide-thumb-active')) { i = k; break; }
        if (i < 0 || i === lastActive) return;
        lastActive = i;
        // Measured from the page, not Swiper's slidesGrid: on this gallery that table runs 80 px past where
        // the thumbnails really are, which was the overshoot.
        var h = sw.isHorizontal(), first = slides[0], last = slides[slides.length - 1];
        function at(e) { return h ? e.offsetLeft : e.offsetTop; }
        function len(e) { return h ? e.offsetWidth : e.offsetHeight; }
        var top = at(slides[i]) - at(first), size = len(slides[i]), view = h ? sw.el.clientWidth : sw.el.clientHeight;
        var max = Math.max(0, at(last) + len(last) - at(first) - view);
        var cur = -sw.translate;
        // After a click or a colorway change: if the selected thumbnail is already whole in view, do not move.
        if (animate && top >= cur - 1 && top + size <= cur + view + 1) return;
        var target = top + size <= view ? 0 : Math.min(max, Math.max(0, top - size / 2));
        sw.setTransition(animate ? 300 : 0);
        sw.setTranslate(-target);
        sw.updateProgress(); sw.updateSlidesClasses();
      }
      // Swiper lays the strip out again as thumbnails load, which undid the first placement at 1440 px and
      // on phones; so place again once the page has loaded, unless the visitor has already moved the strip.
      var touched = false;
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (t) { el.addEventListener(t, function () { touched = true; }, { passive: true }); });
      function again() { if (!touched) { lastActive = -1; place(false); } }
      place(false);
      if (document.readyState !== 'complete') window.addEventListener('load', function () { again(); setTimeout(again, 600); });
      else setTimeout(again, 600);
      setTimeout(again, 1500);
      new MutationObserver(function () { setTimeout(function () { place(true); }, 320); })
        .observe(el, { subtree: true, attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', function () { lastActive = -1; place(false); });
    })();
  }

  function init() {
    initRelated();
    initView();
    initTabs();
    initFilters();
    initIntro();
    watchReveals();
    initHero();
    initHeader();
    initDrawer();
    initMaterials();
    initRails();
    initParallax();
    initFilms();
    initCardHover();
    initThumbStrip();
    initGridPages();
    initColorways();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-run for sections that are added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    watchReveals(event.target);
    initMaterials();
    initRails();
  });
})();

// Collection-head film: silent, and only running while it is on screen.
(function () {
  var v = document.querySelector('.szw-chead__video');
  if (!v || !('IntersectionObserver' in window)) return;
  v.muted = true;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.2 }).observe(v);
})();

// --- big search band ----------------------------------------------------------------------------
// SKUs get typed as SZA0001, sza 0001 or SZA-0001; Shopify only matches what is stored, so the query
// is normalised to the stored "SZA-0001" shape before it is sent.
(function () {
  document.querySelectorAll('[data-szw-bigsearch]').forEach(function (form) {
  var input = form.querySelector('[data-szw-bigsearch-input]');
  var panel = form.querySelector('[data-szw-bigsearch-results]');
  if (!input || !panel) return;
  var timer, controller;

  function normaliseSku(q) {
    var m = q.trim().match(/^([A-Za-z]{2,4})[\s\-_]?(\d{3,5})$/);
    return m ? m[1].toUpperCase() + '-' + m[2] : q;
  }

  // A colour with its own page opens there; otherwise the pattern page with that colorway chosen.
  function skuHref(r) { return r[5] ? '/products/' + r[5] : '/products/' + r[1] + '?variant=' + r[2]; }

  // A SKU or cross-reference number is answered from our own index, so Shopify never hears of it. One quiet
  // request to the store's own search puts what was typed into Shopify's search report with everything else.
  function logSearch(q) {
    try {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1', { keepalive: true })
        .catch(function () {});
    } catch (e) {}
  }

  form.addEventListener('submit', function (e) {
    var raw = input.value.trim();
    if (SKU_SHAPE.test(raw) && skuIndex) {
      var key = raw.toUpperCase().replace(/[\s-]/g, '');
      var hits = skuIndex.filter(function (r) { return r[0].replace(/-/g, '').indexOf(key) === 0; });
      if (hits.length === 1) {                 // an exact SKU goes straight to that colorway
        e.preventDefault();
        logSearch(raw);
        window.location.href = skuHref(hits[0]);
        return;
      }
      if (hits.length > 1) {
        // A SKU PREFIX. Shopify's results page is typo tolerant and would answer "sza" with SZJ, SZT,
        // SZB and SZC as well, so keep the person on the exact list instead of sending them there.
        e.preventDefault();
        renderSkus(hits, raw.toUpperCase());
        return;
      }
    }
    if (xrefNorm(raw).length >= 4) {           // a cross-reference number goes straight to the item it stands for
      if (xrefSeen.q !== raw) {                // typed and entered before the lookup came back: look it up first
        e.preventDefault();
        findXref(raw).then(function (rows) {
          if (rows.length) return goXref(rows, raw);
          input.value = normaliseSku(input.value);
          form.submit();
        });
        return;
      }
      if (xrefSeen.rows.length) { e.preventDefault(); goXref(xrefSeen.rows, raw); return; }
    }
    input.value = normaliseSku(input.value);
  });

  // B1 (launch, 10/10): the per-colour pages (tag "hyper", titled "Pattern: SKU - Colour") come back next to their pattern.
  // One line per design: a colour page is dropped when its pattern is in the list or another colour of it already is.
  function onePerDesign(products) {
    var isColour = function (p) { return (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'hyper'; }); };
    var name = function (p) { return String(p.title || '').split(': ')[0].trim().toLowerCase(); };
    var patterns = {}, seen = {};
    products.forEach(function (p) { if (!isColour(p)) patterns[String(p.title || '').trim().toLowerCase()] = 1; });
    return products.filter(function (p) {
      if (!isColour(p)) return true;
      var k = name(p);
      if (patterns[k] || seen[k]) return false;
      seen[k] = 1;
      return true;
    });
  }

  // 10/12: split designs (snippets/szw-split-designs, printed by sections/szw-header as JSON). An old grouped product whose
  // colours now belong to several designs (Abstract Art -> Facet / Check / Parquet) is suggested as those designs, as on the
  // search results page: each opens its first colour page and shows that page's photo (the flat sample).
  var splitMap = null, drawTok = 0;
  function splitDesigns() {
    if (splitMap) return splitMap;
    splitMap = {};
    var tag = document.querySelector('script[data-szw-split-map]');
    try { if (tag) splitMap = JSON.parse(tag.textContent) || {}; } catch (e) {}
    return splitMap;
  }
  function expandSplit(products) {
    var map = splitDesigns(), out = [];
    products.forEach(function (p) {
      var isColour = (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'hyper'; });
      var ds = !isColour && map[p.handle];
      if (!ds || !ds.length) { out.push(p); return; }
      ds.forEach(function (d) { out.push({ title: d[0], url: '/products/' + d[1], handle: d[1], type: p.type, tags: [], szwRep: d[1] }); });
    });
    return out;
  }
  var repImg = window.__szwRepImg || (window.__szwRepImg = {});
  function repImages(list) {
    return Promise.all(list.filter(function (p) { return p.szwRep && !(p.szwRep in repImg); }).map(function (p) {
      return fetch('/products/' + p.szwRep + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { repImg[p.szwRep] = (j && j.featured_image) || ''; })
        .catch(function () { repImg[p.szwRep] = ''; });
    })).then(function () {
      list.forEach(function (p) { if (p.szwRep) p.featured_image = repImg[p.szwRep]; });
      return list;
    });
  }

  function render(products) {
    products = onePerDesign(expandSplit(products)).slice(0, 8);
    var tok = ++drawTok;
    repImages(products).then(function () {
      if (tok !== drawTok || input.value.trim().length < 2) return;
      draw(products);
    });
  }

  function draw(products) {
    if (!products.length) { panel.hidden = true; panel.innerHTML = ''; return; }
    panel.innerHTML = products.map(function (p) {
      var v = (p.variants || [])[0] || {};
      var sku = v.sku ? String(v.sku).split(' ')[0].split('/')[0] : '';
      // predictive search returns the image as an object on some API versions and a bare URL on others
      var fi = p.featured_image;
      var img = (fi && (fi.url || fi.src)) || (typeof fi === 'string' ? fi : '') ||
                (p.image && (p.image.url || p.image)) || '';
      if (img) img = String(img).split('?')[0] + '?width=160';
      return '<a class="szw-sugg" href="' + p.url + '">' +
        '<span class="szw-sugg__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="52" height="52">' : '') + '</span>' +
        '<span><span class="szw-sugg__name">' + p.title + '</span><br>' +
        '<span class="szw-sugg__meta">' + (sku ? '<span class="szw-sugg__sku">' + sku + '</span>' : '') +
        (p.type ? (sku ? ' · ' : '') + p.type : '') + '</span></span></a>';
    }).join('');
    panel.hidden = false;
  }

  // Shopify's search is typo tolerant, so a SKU prefix like "sza" also matches SZJ, SZT, SZB and SZC -
  // 246 of 274 products. Anything SKU-shaped is matched against our own index instead, exactly.
  var SKU_SHAPE = /^[A-Za-z]{2,4}[-\s]?\d{0,5}$/;
  var skuIndex = null, skuLoading = null;

  function loadSkuIndex() {
    if (skuIndex) return Promise.resolve(skuIndex);
    if (!skuLoading) {
      skuLoading = fetch(form.dataset.skuIndex)
        .then(function (r) { return r.json(); })
        .then(function (d) { skuIndex = d.rows || []; skuXref = d.x || {}; return skuIndex; })
        .catch(function () { skuIndex = []; return skuIndex; });
    }
    return skuLoading;
  }

  // Cross-reference numbers: an old catalogue carried the mill's item numbers, so some people still type those.
  // They must lead to the right Studio Zen item and never show on the site, so the index holds only a salted
  // hash of each number. What was typed is hashed the same way (letters and digits only) - exact match only.
  var skuXref = {}, xrefSeen = { q: null, rows: [] };
  function xrefNorm(q) { return q.toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function findXref(raw) {
    var n = xrefNorm(raw);
    if (n.length < 4 || !window.crypto || !crypto.subtle || !window.TextEncoder) return Promise.resolve([]);
    return loadSkuIndex().then(function (rows) {
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode('szw-xref:' + n)).then(function (buf) {
        var hex = Array.prototype.map.call(new Uint8Array(buf).subarray(0, 8), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
        var skus = skuXref[hex] || [];
        return rows.filter(function (r) { return skus.indexOf(r[0]) > -1; });
      });
    }).catch(function () { return []; });
  }
  function xrefHit(raw) { return xrefSeen.q === raw && xrefSeen.rows.length > 0; }
  function goXref(rows, raw) {
    logSearch(raw);
    if (rows.length === 1) window.location.href = skuHref(rows[0]);
    else renderSkus(rows, '');
  }

  function renderSkus(rows, q) {
    drawTok++;   // a slower name suggestion still on its way must not replace this list
    if (!rows.length) {
      panel.innerHTML = '<p class="szw-sugg__none">No SKU starts with <strong>' + q + '</strong></p>';
      panel.hidden = false;
      return;
    }
    panel.innerHTML = rows.slice(0, 10).map(function (r) {
      return '<a class="szw-sugg" data-szw-sku href="' + skuHref(r) + '">' +
        '<span class="szw-sugg__skubox">' + r[0] + '</span>' +
        '<span><span class="szw-sugg__name">' + r[3] + '</span>' +
        (r[4] ? '<br><span class="szw-sugg__meta">' + r[4] + '</span>' : '') + '</span></a>';
    }).join('') + (rows.length > 10 && q ? '<p class="szw-sugg__none">' + rows.length + ' SKUs start with ' + q + '</p>' : '');
    panel.hidden = false;
  }

  function suggest(raw) {
    var q = normaliseSku(raw);
    if (controller) controller.abort();
    controller = new AbortController();
    var signal = controller.signal;
    var params = 'q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    // 10/14: the same results drawn by sections/szw-search-suggest, whose photo is the flat sample (snippets/szw-flat-image,
    // the grid cards' rule) - suggest.json only knows the lead photo, a 3D render or a room shot on the old grouped products.
    // If that section cannot be read, the plain JSON as before.
    fetch('/search/suggest?' + params + '&section_id=szw-search-suggest', { signal: signal })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-szw-sugg>([\s\S]*?)<\/script>/);
        if (m) return JSON.parse(m[1]);
        return fetch('/search/suggest.json?' + params, { signal: signal })
          .then(function (r) { return r.json(); })
          .then(function (d) { return ((d.resources || {}).results || {}).products || []; });
      })
      .then(function (products) { if (!xrefHit(raw)) render(products); })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var raw = input.value.trim();
    clearTimeout(timer);
    if (raw.length < 2) { panel.hidden = true; return; }

    findXref(raw).then(function (rows) {       // a cross-reference number typed in full shows the item it stands for
      if (input.value.trim() !== raw) return;
      xrefSeen = { q: raw, rows: rows };
      if (rows.length) { clearTimeout(timer); if (controller) controller.abort(); renderSkus(rows, ''); }
    });

    if (SKU_SHAPE.test(raw)) {
      var key = raw.toUpperCase().replace(/[\s-]/g, '');
      timer = setTimeout(function () {
        loadSkuIndex().then(function (rows) {
          if (xrefHit(raw) || input.value.trim() !== raw) return;
          var hits = rows.filter(function (r) { return r[0].replace(/-/g, '').indexOf(key) === 0; });
          // "gold", "silk" and "cork" are SKU-shaped too: only what starts like our SKUs gets the "no SKU" line
          if (hits.length || /^SZ/i.test(raw)) renderSkus(hits, raw.toUpperCase());
          else suggest(raw);
        });
      }, 120);
      return;
    }

    timer = setTimeout(function () { suggest(raw); }, 200);
  });

  // a colour picked from the SKU list was never sent to Shopify's search: note what was typed
  panel.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[data-szw-sku]')) logSearch(input.value.trim());
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) panel.hidden = true;
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') panel.hidden = true;
  });
  });
})();

// On a phone the magnifier opens the header search field in place, rather than jumping to a search page.
(function () {
  var header = document.querySelector('[data-szw-header]') || document.querySelector('.szw-header');
  var toggle = document.querySelector('[data-szw-search-toggle]');
  if (!header || !toggle) return;
  var field = header.querySelector('[data-szw-bigsearch-input]');
  toggle.addEventListener('click', function () {
    var open = header.classList.toggle('is-searching');
    toggle.setAttribute('aria-expanded', String(open));
    if (open && field) field.focus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && header.classList.contains('is-searching')) {
      header.classList.remove('is-searching');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
})();
